
import { supabase } from "@/integrations/supabase/client";

// Clean up auth state to prevent authentication limbo states
export const cleanupAuthState = () => {
  // Remove standard auth tokens
  localStorage.removeItem('auth_token');

  // Remove all Supabase auth keys from localStorage
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      localStorage.removeItem(key);
    }
  });
};

export const validateCredentials = async (email: string, password: string): Promise<boolean> => {
  try {
    // Clean up any existing auth state first
    cleanupAuthState();
    
    console.log('Attempting Supabase login with:', email);
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    });
    
    if (error) {
      console.error('Supabase authentication error:', error.message);
      return false;
    }
    
    console.log('Authentication successful:', data.user?.email);
    return !!data.user;
  } catch (err) {
    console.error('Login process error:', err);
    return false;
  }
};

export const isAuthenticated = async (): Promise<boolean> => {
  try {
    const { data } = await supabase.auth.getSession();
    return !!data.session;
  } catch (err) {
    console.error('Error checking authentication status:', err);
    return false;
  }
};

export const login = async (email: string, password: string): Promise<boolean> => {
  const success = await validateCredentials(email, password);
  if (success) {
    // The session is automatically handled by Supabase
    return true;
  }
  return false;
};

export const logout = async (): Promise<void> => {
  // Clean up auth state first
  cleanupAuthState();
  
  // Sign out from Supabase
  try {
    await supabase.auth.signOut({ scope: 'global' });
  } catch (err) {
    console.error('Error during logout:', err);
  }
  
  // Force reload the page to ensure clean state
  window.location.href = '/login';
};
